<template>
  <div>
    <div class="filters" style="margin-top: 10px; margin-left: 5px">
      <el-form :inline="true" label-width="80px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item :label="labelName">
            <!--起运港/目的港-->
            <cargo-advance-select
              v-if="params.itemType === 'select'"
              :disabled="readOnly"
              filterable
              :select-type="params.dataCacheKey"
              :method-params="params.methodParams || {}"
              :default-value="criteriaValue"
              style="width: 300px"
              @parentCallBack="getValueFromChild"
            />
            <!--HS Code-->
            <el-input
              v-if="params.itemType === 'input'"
              v-model="criteriaValue"
              v-uppercase
              :disabled="readOnly"
              style="width: 286px;"
            />
          </el-form-item>
          <el-form-item>
            <el-button :disabled="readOnly" type="primary" @click="add">{{ $t('CargoMsg.Cargo_add') }}</el-button>
            <el-button :disabled="readOnly" type="danger" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            <el-checkbox
              v-model="innerNotEmpty"
              :disabled="readOnly || rowData.length > 0"
              style="margin-left: 10px;"
            >{{ $t('advanceSearchForm.Is_Not_Null') }}</el-checkbox>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="section grid-wrapper" style="min-height: 400px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'CargoMultiConditionDetail',
  components: { cargoAdvanceSelect },
  props: {
    params: { type: Object, required: true },
    rowData: { type: Array, default: () => [] },
    itemLabel: { type: String, default: '' },
    readOnly: { type: Boolean, default: false },
    notEmpty: { type: Boolean, default: false }
  },
  data() {
    return {
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true,
          suppressMenu: true
        },
        pagination: false
      },
      originRowData: [],
      criteriaValue: '',
      innerNotEmpty: this.notEmpty
    }
  },
  computed: {
    labelName() {
      return this.i18nAdvSearch('' + this.params.itemLabel)
    },
    columnDefs() {
      return [
        {
          headerName: this.labelName,
          flex: 1,
          field: '',
          cellRenderer: params => {
            return this.params.itemType === 'input' ? params.data : this.portCellRenderHandler(params.data)
          }
        }
      ]
    }
  },
  watch: {
    notEmpty(newVal) {
      this.innerNotEmpty = newVal
    },
    innerNotEmpty(newVal) {
      this.$emit('update:notEmpty', newVal)
    },
    rowData(newVal) {
      if (newVal.length > 0) {
        this.innerNotEmpty = true
      }
    }
  },
  methods: {
    getValueFromChild(obj) {
      this.criteriaValue = obj.value ? obj.value : ''
    },
    add() {
      if (!this.criteriaValue) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.labelName)
        return
      }
      const self = this
      const existsRows = this.rowData.filter(row => {
        return String(row) === String(self.criteriaValue)
      })
      if (existsRows.length > 0) {
        this.$message.error(self.$t('common.tips.repeatedlyTip'))
      } else {
        this.rowData.push(this.criteriaValue)
        // this.notifyParent()
      }
      this.gridOptions.api.setRowData(this.rowData)
      this.criteriaValue = ''
    },
    remove() {
      if (this.rowData.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneOnly'))
        return
      }
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (selectedRow) {
        const index = this.rowData.findIndex(row => row === selectedRow)
        if (index > -1) {
          this.rowData.splice(index, 1)
          this.gridOptions.api.refreshCells({ force: true })
        }
      } else {
        this.$message.error(this.$t('common.tips.hasOneOnly'))
      }
    },
    portCellRenderHandler(value) {
      let sourceField = 'code'
      let targetField = 'chineseName'
      if (this.params.dataCacheKey === 'basic_data_User') {
        sourceField = 'userId'
      }
      if (this.params.dataCacheKey === 'basic_data_Company') {
        sourceField = 'cmpIdx'
      }
      if (this.params.dataCacheKey === 'basic_data_Region') {
        targetField = 'name'
      }
      if (this.params.dataCacheKey === 'basic_data_Seaport') {
        targetField = 'englishName'
      }
      const result = ColumnUtils.resolveColumnLabel(this.params.dataCacheKey, sourceField, value, targetField)
      return result || ''
    },
    i18nAdvSearch(key) {
      const name = `${key}`
      const value = this.$t(`${key}`)
      if (value === name) {
        return key
      }
      return value
    }
  }
}
</script>
